export const BAR_CHART: Highcharts.Options = {
  chart: {
    type: "bar",
  },
  title: {
    text: "",
  },
  xAxis: {
    visible: true,
    categories: [],
    gridLineWidth: 0,
    lineWidth: 1,
    title: {
      text: null,
    },
  },
  yAxis: {
    visible: true,
    min: 0,
    title: {
      text: undefined,
      align: "high",
    },
  },
  plotOptions: {
    series: {
      dataLabels: {
        enabled: false,
      },
    },
  },
  credits: {
    enabled: false,
  },
  tooltip: {
    valueSuffix: "",
  },
  series: [],
  legend: {
    enabled: false,
  },
  exporting: {
    enabled: true,
    fallbackToExportServer: true,
    buttons: {
      contextButton: {
        align: "right",
        verticalAlign: "top",
        y: -43,
        x: -30,
      },
    },
  },
  accessibility: {
    enabled: false,
  },
};
